import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Container, Breadcrumb, BreadcrumbItem, Card, CardBody, Button } from 'reactstrap'
import { eventDirectoryLocation } from 'pages/EventsManagement/directoryQuery'
import { getEventDetails } from '../../../actions'
import { EVENT_DETAILS_READ_MODE_ANNOUNCEMENTS } from '../../../eventDetailsReadPolicy'
import AnnouncementEditor from '../Annoncements/AnnouncementEditor'
import { readAnnouncementContent } from '../Annoncements/announcementContent'
import '../Annoncements/announcements.scss'

export const AddAnouncement = ({ eventDetails, error = '', match, fetchEvents, history, location }) => {
  const { eventId, announcementId } = match.params
  useEffect(() => { fetchEvents(eventId, EVENT_DETAILS_READ_MODE_ANNOUNCEMENTS) }, [fetchEvents, eventId])
  const event = eventDetails?.find(item => item._id === eventId)
  const loaded = Boolean(event && Array.isArray(event.competitions) && Array.isArray(event.announcements))
  const announcement = event?.announcements?.find(item => item._id === announcementId && item.status !== 'DELETED')
  const unavailable = loaded && announcementId && (!announcement || !readAnnouncementContent(announcement.message).valid)
  return <div className="page-content"><Container fluid>
    <Breadcrumb>
      <BreadcrumbItem><Link to={eventDirectoryLocation()}>Events</Link></BreadcrumbItem>
      <BreadcrumbItem>{event ? <Link to={`/events/${eventId}/announcements`}>Event: {event.name}</Link> : error ? 'Event unavailable' : 'Event: Loading...'}</BreadcrumbItem>
      <BreadcrumbItem active>{announcementId ? 'Edit announcement' : 'Add announcement'}</BreadcrumbItem>
    </Breadcrumb>
    <h4>{announcementId ? 'Edit Announcement' : 'Add Announcement'}</h4>
    {!loaded || unavailable ? <Card><CardBody>
      <p role={error || unavailable ? 'alert' : 'status'}>{unavailable ? 'This announcement is unavailable or its content cannot be read safely.' : error ? 'Could not load event data.' : 'Loading event data...'}</p>
      {(error || unavailable) && <div className="d-flex flex-wrap">
        <Button onClick={() => fetchEvents(eventId, EVENT_DETAILS_READ_MODE_ANNOUNCEMENTS)}>Retry</Button>
        <Link className="btn btn-link" to={`/events/${eventId}/announcements`}>Back to Announcements</Link>
      </div>}
    </CardBody></Card> : <AnnouncementEditor key={`${eventId}:${announcementId || 'new'}`} event={event} announcement={announcement} history={history} preselectedCompetition={location?.state?.competitionId} />}
  </Container></div>
}

const mapStateToProps = ({ events: { eventDetails = [], error = '' } = {} }) => ({ eventDetails, error })
export default connect(mapStateToProps, { fetchEvents: getEventDetails })(AddAnouncement)
